import { Component } from '@angular/core';
import { IApplicationFilters, IFilterOption } from '../../shared.definitions';
import { CollectionFilterService } from '../../services/collection-filter.service';

@Component({
  selector: 'app-collection-filters',
  templateUrl: './collection-filters.component.html',
  styleUrls: ['./collection-filters.component.scss'],
})
export class CollectionFiltersComponent {
  isCityFilterOpen = false;
  isAccomodationTypeFilterOpen = false;
  isAccomodationClassFilterOpen = false;

  constructor(readonly filterService: CollectionFilterService) {}

  filterActive(filters: IFilterOption[]): any {
    return filters.findIndex((f) => f.checked) > -1;
  }

  onClearFilter(filterType: keyof IApplicationFilters): void {
    this.filterService.resetFilter(filterType);
  }

  onOptionClick(option: IFilterOption): void {
    option.checked = !option.checked;

    this.filterService.updateFilters(JSON.parse(JSON.stringify(this.filterService.getFilters())));
  }

  accomodationClassText(text: string): string {
    return text.trim().endsWith('𝐒') ? text + 'uperior' : text;
  }

  isHotelSelected(activeFilters): boolean {
    return activeFilters.accomodationType.some((item) => item.id === 1 && item.checked === true);
  }

  isAccomodationTypeUnchecked(activeFilters): boolean {
    return activeFilters.accomodationType.every((item) => item.checked === false);
  }

  isOnlyNonClassifiedSelected(activeFilters): boolean {
    const checkedItems = activeFilters.accomodationType.filter((item) => item.checked);

    return checkedItems.every((item) => item.id === 6 || item.id === 7) && checkedItems.length > 0;
  }
}
